import { cn, tv, VariantProps } from "@utils/tw"
import { ComponentProps, PropsWithChildren } from "react"

export type ButtonGroupProps = ComponentProps<"div"> & VariantProps<typeof buttonGroupStyles>

export function ButtonGroup(props: ButtonGroupProps) {
  return (
    <div {...props} className={cn(buttonGroupStyles(props), props.className)}>
      {props.children}
    </div>
  )
}

const buttonGroupStyles = tv({
  base: `flex gap-4 @sm:flex`,
  variants: {
    variant: {
      default: "gap-4",
      tight: "gap-2",
      dialog: "gap-4 [&_>*]:flex-1 @sm:justify-end @sm:[&_>*]:flex-none flex-wrap",
    },
  },
})
